import { Block } from '@chameleoncreator/creator-app';
import getStore from 'services/getStore';

export default (type: string, key: string | undefined = undefined) => {
  const blocks = Object.values<Block>(getStore().getState().blocks).filter(
    (b: any) => b.type === type
  );

  if (key) {
    return blocks.map(b => b[key])
  }

  return blocks;
};
